module.exports = __webpack_public_path__ + "img/stick_restauration_producteurs_vin.3e00c7e7.svg";